import React, { Component } from 'react';
import _, { isEmpty, size } from 'lodash';
import axios from 'axios';

import { Alert, Avatar, Box, Button, Card, CardHeader, Divider, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Paper, Typography } from '@mui/material';
import { CheckCircleOutlined, ChevronRightOutlined, Close, EditRounded, ErrorOutlined, ExpandLess, ExpandMore, InfoOutlined, ReplayOutlined, SubdirectoryArrowRightRounded, SyncOutlined } from '@mui/icons-material';
import Dialog from '../../common/Dialog';
import { amber, blue, green, grey, orange } from '@mui/material/colors';
import DemandChanges from './DemandChanges';
import withStyles from '@mui/styles/withStyles';
import EquipDemandUpdateLine from './EquipDemandUpdateLine';

const styles = theme => ({
    nested: {
        paddingLeft: theme.spacing(8),
    },
    indent: {
        marginLeft: theme.spacing(10),
    },
    large: {
        width: theme.spacing(15),
        height: theme.spacing(15),
        margin:"auto 10px"
    },
});

class EmployeeLoanDemandSingle extends Component {
    state = {  
        openContract: false,
        user: {},
        loan: {},
        index: 0,
        details: [],
        defaultItemDemand: {},
        openAttribute: false,
        total: 0,
        currentForm: "",
        currentIndex: 1,
        currentLine: {},
        openReplace: false,
        toUpdate: 1, // for init only
        openLoanList: {}
    }
    componentDidMount = () => {

        // if (isEmpty(this.props.LOAN_DEMANDS[this.props.DEMAND.demand_loan_id])){
        //     await this.props.fetchLoanDemandDetails(this.props.DEMAND.demand_loan_id)
        //     // or axios

        // }

        this.fetchDetails()
    }
    fetchDetails = async () => {
        const res = await axios.post("/loans/demands/details", {demandID: this.props.DEMAND.demand_loan_id}) 
        if (res.data) {
            if (res.data.error) {
                console.log('==== get Demand Details ================');
                console.log(res.data.error);
                console.log('====================================');
            } else {
                let total = 0
                let rest = 0
                let updates = 0
                let openLoanList = {}
                let addByAdmin = []
                let addByUser = []
                res.data.forEach( info => {
                    if (info.demand_line.add_by_admin) {
                        addByAdmin.push(info)
                    } else {
                        addByUser.push(info)
                    }
                    total += info.demand_line.line_quantity
                    rest += info.rest
                    // max[info.demand_line.line_equipement] = size(info.available) > info.rest ? info.rest : size(info.available)
                    info.loan_list.forEach(loan => {
                        if (loan.loan_status == "RESA_UPDATED") {
                            updates += 1
                            openLoanList[info.equipement.equipement_id] = true
                        }
                    })
                })
                let details = addByUser.concat(addByAdmin)
                this.setState({
                    details,
                    total,
                    rest,
                    toUpdate: updates ,
                    openLoanList,
                })
            }
        } else {
            console.log('==== get Demand Details ================');
            console.log("no Response");
            console.log('====================================');
        }
    }
    handleReplace = () => {
        this.setState({
            openReplace : true
        })
    }
    getLoansList = (info) => {
        const { LOANS, classes, DEMAND } = this.props;
        let history = info.loan_list.map( LOAN => 
            <>
                {LOANS[LOAN.loan_id] && 
                    <ListItem className={classes.nested} >
                        {(LOAN.loan_status === "RESA_UPDATED") &&
                        // {(LOANS[LOAN.loan_id].is_different_from_demand && !LOANS[LOAN.loan_id].user_accept_changes) ?
                        // {LOANS[LOAN.loan_id].equipement.duplicate_from != info.demand_line.line_equipement ?
                            <>
                                <Box p={1}>
                                    <SubdirectoryArrowRightRounded fontSize="small" sx={{ color: grey[600] }} />
                                </Box>
                                <ListItemText 
                                    primary={
                                        <Typography variant="h6" color="error">
                                            <b>{LOANS[LOAN.loan_id].equipement.equipement_name}</b>
                                        </Typography>
                                    } 
                                    secondary={LOANS[LOAN.loan_id].equipement.equipement_ref}
                                />
                                {DEMAND.demand_status == "DEMAND_UPDATED"  && 
                                    <ListItemSecondaryAction>
                                        <ListItemText secondary={
                                            // <Typography variant="h6" color="primary">
                                            //     x {demand.demand_quantity}
                                            // </Typography>
                                            <Button variant="contained" color="secondary" onClick={() => this.handleAcceptChanges( info.equipement, LOANS[LOAN.loan_id])}>
                                                Vérifier
                                            </Button>
                                        } />
                                    </ListItemSecondaryAction>
                                }
                            </>
                        }
                        {(LOAN.loan_status !== "RESA_CANCELED" && LOAN.loan_status != "RESA_UPDATED" ) &&
                            <>
                                <Box p={1}>
                                    <SubdirectoryArrowRightRounded fontSize="small" sx={{ color: grey[600] }} />
                                </Box>
                                <ListItemText 
                                    primary={
                                        <Typography variant="h6" color={green[500]}>
                                            {LOANS[LOAN.loan_id].equipement.equipement_name} 
                                        </Typography>
                                    } 
                                    secondary={LOANS[LOAN.loan_id].equipement.equipement_ref}
                                />
                                {DEMAND.demand_status == "DEMAND_UPDATED"  && 
                                    <ListItemSecondaryAction>
                                        <ListItemText secondary={
                                            // <Typography variant="h6" color="primary">
                                            //     x {demand.demand_quantity}
                                            // </Typography>
                                            <Button variant="contained" color="error" onClick={() => this.deleteResa(LOANS[LOAN.loan_id])}>
                                                Annuler
                                            </Button>
                                        } />
                                    </ListItemSecondaryAction>
                                }
                            </>
                        }
                        {(LOAN.loan_status === "RESA_CANCELED") &&
                            <>
                                <Box p={1}>
                                    <Close fontSize="small" sx={{ color: grey[500] }} />
                                </Box>
                                <ListItemText 
                                    style={{textDecoration: "line-through"}}
                                    primary={
                                        <Typography variant="body1" color={grey[400]}>
                                            {LOANS[LOAN.loan_id].equipement.equipement_name} 
                                        </Typography>
                                    } 
                                    secondary={LOANS[LOAN.loan_id].equipement.equipement_ref}
                                />
                            </>
                        }
                        </ListItem>
                }
            </>
            )
       
        return history
    }
    openList = (equipID) => {
        let list = Object.assign({}, this.state.openLoanList)
        list[equipID] = !!!list[equipID]
        this.setState({
            openLoanList: list
        })
    }
    handleSubmit =  async () => {
        await this.props.updateDemandLoanStatusUser(this.props.DEMAND.demand_loan_id)
        if(this.props.STATE.loanDemands.error){
            this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loanDemands.error}`)
        } else { 
            this.props.notif("success", "Enregistré")
            this.handleClose()
        }
        
    }
    handleAcceptChanges = (equipement, loan) => {
        this.setState({
            openChanges: true,
            changeLoan: loan,
            changeDemand: this.props.DEMAND,
            changeEquipement: equipement
        })
    }
    handleClose = (equipement, loan) => {
        this.setState({
            openChanges: false,
            openReplace: false,
            changeLoan: {},
            changeDemand: {},
            changeEquipement: {}
        })
        this.fetchDetails()
    }
    deleteResa = async (loan) => {
        let newLoan = Object.assign({}, loan)
        newLoan.loan_status = "RESA_CANCELED"
        await this.props.updateResaLoanUser(newLoan)
        // notif success
        if(this.props.STATE.loans.error){
            this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loans.error}`)
        } else { 
            this.props.notif("success", "Reservation annulée")
            this.handleClose()
        }
    }
    render() {
        const { DEMAND, classes } = this.props;
        const {  details, currentLine, openLoanList, toUpdate } = this.state;

        // let list = this.filterList()
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                close={this.props.handleCloseAll}
                maxWidth="lg"
                fullScreen
                scroll="paper"
                title={`Demande du ${new Date(DEMAND.demand_creation_date).toLocaleDateString("fr-FR")} `}
                appBar
                secondaryAction={DEMAND.demand_status == "DEMAND_UPDATED" && 
                    <IconButton
                        onClick={() => this.handleReplace()}
                    >
                        <EditRounded />
                    </IconButton>
                }
                submitAction={(DEMAND.demand_status == "DEMAND_UPDATED" && toUpdate === 0) && this.handleSubmit}
                submitTitle={"Valider les changements"}
            >
                {this.state.openChanges &&
                    <DemandChanges
                        {...this.props}
                        handleClose={this.handleClose}
                        loan={this.state.changeLoan}
                        demand={this.state.changeDemand}
                        equipement={this.state.changeEquipement}
                    />
                }
                {this.state.openReplace &&

                    <EquipDemandUpdateLine
                        {...this.props}
                        handleClose={this.handleClose}
                        
                    />
                }
                <Box>
                    {/* <Card> */}
                    <Box p={1}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box p={3}>
                                    <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Date d'emprunt souhaitée : 
                                        <b> {new Date(DEMAND.demand_start_date).toLocaleDateString("fr-FR")}</b>
                                    </Box>
                                    <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Date de fin prévue : 
                                        <b> {new Date(DEMAND.demand_end_date).toLocaleDateString("fr-FR")}</b>
                                    </Box>
                                    <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Durée : 
                                        <b> {(new Date(DEMAND.demand_end_date) - new Date(DEMAND.demand_start_date))/1000/60/60/24 } jours</b>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <Box p={3} style={{ borderLeft : "1px solid lightgray"}}>
                                    <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Nombre total d'articles: 
                                        <b> {this.state.total}</b>
                                    </Box>
                                    <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Usage prévu: 
                                        <b> {DEMAND.demand_remarks}</b>
                                    </Box>
                                    <Box p={1} >
                                        <Typography variant="button" color={blue[600]} style={{display: "flex", justifyContent: "space-between"}}>
                                            <b>Actions en attente:</b> <b>{this.state.toUpdate}</b>
                                        </Typography>
                                    </Box>
                                    {/* <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Nombre total d'articles en attente: 
                                        <b> {this.state.rest}</b>
                                    </Box> */}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    {/* </Card> */}
                    <Box>
                        <Grid item xs={12} sm={6}>
                            <CardHeader 
                                subheader="Liste des Matériels" 
                            />
                            <Box p={2}>
                                <List>
                                    {!isEmpty(details) && details.map((infos, i) =>
                                    <>
                                        <ListItem 
                                            alignItems="flex-start"
                                            // style={{background:(i % 2 === 0 ? "rgb(224 247 250 / 60%)" : "white")}}
                                            key={infos.equipement.equipement_id}
                                        >
                                            {infos.demand_line.add_by_admin &&
                                            <Box p={1} style={{margin: "auto"}}>
                                                <Typography color="secondary">
                                                    <i>nouveau</i>
                                                </Typography>
                                            </Box>
                                            }
                                            <ListItemAvatar>
                                                <Avatar 
                                                    variant="rounded" 
                                                    alt={infos.equipement.equipement_original_name} 
                                                    src={`/photos/single/${infos.equipement.equipement_photo_front.filename}`} 
                                                    className={classes.large}
                                                />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={
                                                    <React.Fragment>
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="h5"
                                                            color="primary"
                                                        >
                                                            <b>{infos.demand_line.line_quantity} </b>
                                                        </Typography>
                                                        {infos.demand_line.line_quantity !== infos.demand_line.line_quantity_initial &&
                                                            <Typography
                                                                sx={{ display: 'inline', textDecoration:"line-through" }}
                                                                component="span"
                                                                variant="body1"
                                                                // color=""
                                                            >
                                                                / {infos.demand_line.line_quantity_initial}
                                                            </Typography>

                                                        }
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="h6"
                                                            color="text.primary"
                                                        >
                                                            {" "} x {infos.equipement.equipement_original_name}
                                                        </Typography>
                                                        <Typography
                                                            // component="span"
                                                            variant="body1"
                                                            color="text.secondary"
                                                        >
                                                            {" "}{infos.equipement.equipement_brand}
                                                        </Typography>
                                                                                                                
                                                    </React.Fragment>
                                                }
                                                secondary={
                                                    <React.Fragment>
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="body1"
                                                            color="text.primary"
                                                        >
                                                            <i>{" — "}{infos.demand_line.line_remarks}</i>
                                                        </Typography>
                                                        <br />
                                                        {/* <Alert severity={size(infos.available) >= infos.rest ? "success" : "error"}>
                                                        {" Disponible: "}{size(infos.available)}
                                                        </Alert> */}
                                                    </React.Fragment>
                                                }
                                            />
                                            
                                            <Button
                                                onClick={ () => this.openList(infos.equipement.equipement_id)}
                                                size="large"
                                                endIcon={openLoanList[infos.equipement.equipement_id] ? <ExpandLess /> : <ExpandMore />}
                                            >
                                                Réservation

                                            </Button>
                                        </ListItem>
                                        {openLoanList[infos.equipement.equipement_id] &&
                                            <Paper className={classes.indent} >
                                                {this.getLoansList(infos)}
                                            </Paper>
                                        }            
                                        <Box p={1}>
                                            <Divider />
                                        </Box>                                                                      
                                    </>
                                    )}
                                </List>
                            </Box>
                        </Grid>

                    </Box>

                </Box>

            </Dialog>
        );
    }
}

export default withStyles(styles)(EmployeeLoanDemandSingle);